<template>
  <div class="py-5 text-center abbv-wrapper">
    <div class="container text-center">
      <div v-html="$t('Footer.legalrules')" class="abbrev-terms"></div>
    </div>
  </div>
  <footer class="py-4">
    <div class="container-fluid px-4 py-0">
      <div class="row align-items-center gap-0 row-gap-3">
        <div class="col-md-1 text-center">
          <img src="https://snippcheck.blob.core.windows.net/files/pep_Zevo_Walmart_NFL_Sweeps_2009033/images/pg-logo.svg" alt="P&G Logo" class="img-fluid footer-logo">
        </div>
        <div class="col-md-11">
          <ul class="list-inline footer-links" id="footer-nav">
            <li class="list-inline-item ps-0">
              <a aria-label="Do Not Sell or Share My Personal Information / Opt-Out of Targeted Advertising"
                role="button" href="javascript:void(0)" onclick="Optanon.ToggleInfoDisplay();">
                {{ $t('Footer.DoNotSellLink') }}
              </a>
            </li>
            <li class="list-inline-item">
              <a aria-label="Terms & Conditions - visiting link that opens in a new tab" rel="noopener noreferrer"
                href="https://termsandconditions.pg.com/en-us/" target="_blank">
                {{ $t('Footer.T&CLink') }}
              </a>
            </li>
            <li class="list-inline-item">
              <a aria-label="Accessibility Statement - visiting link that opens in a new tab" rel="noopener noreferrer"
                href="https://accessibility.pg.com/en-us" target="_blank">
                {{ $t('Footer.AccessibilityLink') }}
              </a>
            </li>
            <li class="list-inline-item">
              <a aria-label="Contact Us - visiting link that opens in a new tab"
                href="http://www.pg.com/en_US/contact_us/index.shtml" target="_blank">
                {{ $t('Footer.ContactUsLink') }}
              </a>
            </li>
            <li class="list-inline-item">
              <a aria-label="Privacy - visiting link that opens in a new tab" rel="noopener noreferrer"
                href="https://privacypolicy.pg.com/en/#statePrivacyNotice" target="_blank">
                {{ $t('Footer.PrivayPolicyLink') }}
              </a>
            </li>
            <li class="list-inline-item">
              <a aria-label="Consumer Health Data Privacy Policy - visiting link that opens in a new tab"
                href="https://privacypolicy.pg.com/CHD-en" target="_blank">
                {{ $t('Footer.ConsumerHealthDataPrivacyPolicyLink') }}
              </a>
            </li>
            <li class="list-inline-item">
              <a href="https://preferencecenter.pg.com/en-us/" target="_blank" data-action-detail="AdChoices"
                aria-label="Your Privacy Choices - visiting link that opens in a new tab">
                {{ $t('Footer.YourPrivacyChoicesLink') }}
                <img src="https://snippcheck.blob.core.windows.net/files/PGLocalValues/privacyoptions.png" alt="Privacy Options"
                  class="img-fluid">
              </a>
            </li>
          </ul>
          <p>
            <small>
              {{ $t('Footer.FooterNotice') }}

            </small>
          </p>
          <p class="mb-0">
            <small>
              {{ $t('Footer.copyrighttext') }}
            </small>
          </p>
      </div>
    </div>
    </div>
  </footer>
</template>

<script>

</script>